// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageContainer_pageContainer__2C087","footerContainerDiv":"PageContainer_footerContainerDiv__TtzM4"};